import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DonorFrequencyDistributionChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: ["1x", "2x", "3x", "4x", "5x+"],
      datasets: [
        {
          label: t("Number of Donors"),
          data: [data.oneTime, data.twoTimes, data.threeTimes, data.fourTimes, data.fivePlusTimes],
          backgroundColor: "#3b4cb8",
          borderColor: "#3b4cb8",
          borderWidth: 1,
          barThickness: 40,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 500,
            stepSize: 100,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Donors"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: t("Donations Per Year"),
            fontColor: "#666",
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Donors")}: ${tooltipItem.yLabel}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "300px", position: "relative" }}>
      <Bar data={chartData} height={300} options={options} />
    </div>
  );
};

export default DonorFrequencyDistributionChart;
